import { ajaxGetAnon } from './AjaxHelper.js';

export function getDocumentLabels(languageId, callback) {
    ajaxGetAnon("/api/documentlabels?languageId=" + languageId + "&sectionId=1&members=true", (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getDocumentLabelsProject(languageId, callback) {
    ajaxGetAnon("/api/documentlabels?languageId=" + languageId + "&sectionId=2&members=false", (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getDocumentLabelsCandidate(languageId, callback) {
    ajaxGetAnon("/api/documentlabels?languageId=" + languageId + "&sectionId=4&members=false", (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getDocumentLabelsSignal(languageId, callback) {
    ajaxGetAnon("/api/documentlabels?languageId=" + languageId + "&sectionId=3&members=false", (data, ok) => {
        callback(ok ? data : null);
    });
}


// WEBPACK FOOTER //
// ./src/Api/DocumentLabels.js